module.exports = __webpack_public_path__ + "static/media/winter-che-routes@2x.e7150cbb.png";